export {default as MappingMode}						from "./textures/MappingMode";
export {default as Single2DTexture}					from "./textures/Single2DTexture";
export {default as SingleCubeTexture}				from "./textures/SingleCubeTexture";
export {default as TextureBase}						from "./textures/TextureBase";